import type { PartnerKeyStatisticsFilterDto } from "Infrastructure/Api/Api";
import { useMarket } from "Market/Providers/CurrentMarketProvider";
import { useMemo } from "react";
import { useSearchParams } from "react-router";

export const usePartnerStatisticsFilter = (): PartnerKeyStatisticsFilterDto => {
	const [query] = useSearchParams();
	const { market } = useMarket();

	return useMemo(
		() => ({
			regionId: query.get("regionId")
				? Number(query.get("regionId"))
				: undefined,
			marketId: query.get("marketId")
				? Number(query.get("marketId"))
				: market?.id
					? Number(market.id)
					: undefined,
		}),
		[query],
	);
};
